<div class="container-informations">
  <div class="flex">
    <span class="small-padding-informations"><b>Je suis :</b></span>
    <kendo-dropdownlist
      [data]="listTypeClient"
      [(value)]="typeClient"
      (selectionChange)="clientTypeChange($event)"
      class="selection-form-individual-company"
    >
    </kendo-dropdownlist>
  </div>
  <div class="company-block-informations" *ngIf="typeClient === 'responsable de formation'">
    <form [formGroup]="formCompanyInformations" *ngIf="!!typeClient" (ngSubmit)="formUpdateCompany()">
      <!-- Formulaire Infos Organisation -->
      <div class="company-block-informations">
        <div class="container-block-form-informations">
          <h5>Informations de l'organisation</h5>

          <div class="row-informations">
            <div class="column-errors-input">
              <input
                id="ime"
                kendoTextBox
                [placeholder]="'Nom de l\'organisation'"
                formControlName="raisonSociale"
                class="input-informations"
                [attr.disabled]="userConnectedInfo.company.name ? '' : null"
              />
              <div
                class="errors-profile-informations alert-color"
                *ngIf="formCompanyInformations.get('raisonSociale').invalid && submitted"
              >
                Veuillez renseigner le nom de l'organisation
              </div>
            </div>
          </div>

          <div class="container-input-combobox">
            <div class="input-column">
              <div class="column-errors-input-combobox">
                <kendo-combobox
                  [data]="listTypeEntreprise"
                  [textField]="'libelle'"
                  [valueField]="'id'"
                  [placeholder]="'Type d\'entreprise*'"
                  formControlName="typeEntreprise"
                  class="input-combobox"
                  [attr.disabled]="userConnectedInfo.company.type ? '' : null"
                >
                </kendo-combobox>
                <div
                  class="errors-profile-informations alert-color"
                  *ngIf="formCompanyInformations.get('typeEntreprise').invalid && submitted"
                >
                  Veuillez renseigner le type d'entreprise
                </div>
              </div>
            </div>
            <div class="input-column">
              <div class="column-errors-input-combobox">
                <input
                  kendoTextBox
                  (keyup)="onKey($event)"
                  [placeholder]="'SIREN / SIRET*'"
                  formControlName="siret"
                  class="informations-combobox-input"
                  [attr.disabled]="userConnectedInfo.company.siren ? '' : null"
                />
                <div
                  class="errors-profile-informations alert-color"
                  *ngIf="formCompanyInformations.get('siret').invalid && submitted"
                >
                  Numéro de SIRET/SIREN invalide
                </div>
              </div>
            </div>
          </div>

          <div class="row-informations">
            <div class="column-errors-input">
              <input
                kendoTextBox
                [placeholder]="'TVA intracommunautaire*'"
                formControlName="tva"
                name="tva"
                class="input-informations"
                [attr.disabled]="userConnectedInfo.company.tva ? '' : null"
              />
              <div
                class="errors-profile-informations alert-color"
                *ngIf="formCompanyInformations.get('tva').invalid && submitted"
              >
                Veuillez renseigner votre TVA
              </div>
            </div>
          </div>

          <div class="block-validation-informations">
            <!--<div class="validation-informations">-->
            <!--<p>-->
            <!--DISCLAIMER RGPD, Crebriores animi quorum et turbela maerens protector domesticus populari quo quae-->
            <!--praeteritis prohibebant animi domesticus torrentes Hermogenis egerat protector potuit.-->
            <!--</p>-->

            <!--TODO REMOVE Commentaire when CGV function avaible -->
            <!--<input formControlName="cgv" type="checkbox" id="cdc1" class="k-checkbox" />-->
            <!--<label-->
            <!--[ngClass]="-->
            <!--submitted && formCompanyInformations.get('cgv').invalid-->
            <!--? 'errors-profile-informations alert-color k-checkbox-label font-size-16'-->
            <!--: 'k-checkbox-label'-->
            <!--"-->
            <!--for="cdc1"-->
            <!--&gt;-->
            <!--Je valide les <a (click)="getCGV()" title="conditions générales<">&nbsp;conditions générales&nbsp; </a> de-->
            <!--vente.-->
            <!--</label>-->
            <!--</div>-->

            <div class="validation-informations">
              <button   class="small-margin colored-text" kendoButton>
                <ng-container *ngIf="!loading; else buttonSubmitted">
                  Suivant
                </ng-container>
                <ng-template #buttonSubmitted>
                  Chargement...
                </ng-template>
              </button>
            </div>
          </div>

          <!-- Formulaire Infos Responsable -->
        </div>
        <div class="container-block-form-informations">
          <h5>informations du responsable</h5>
          <div class="container-two-column">
            <div class="column-errors-input">
              <kendo-combobox
                [attr.disabled]="userConnectedInfo.userInfo.civ ? '' : null"
                [data]="listCiv"
                [placeholder]="'Civ.'"
                formControlName="civ"
                class="civility-informations"
              >
              </kendo-combobox>
              <div
                class="errors-profile-informations alert-color"
                *ngIf="formCompanyInformations.get('civ').invalid && submitted"
              >
                Veuillez renseigner votre civilité
              </div>
            </div>
            <div class="column-errors-input">
              <input
                [attr.disabled]="userConnectedInfo.userInfo.name ? '' : null"
                kendoTextBox
                [placeholder]="'Nom'"
                formControlName="nom"
              />
              <div
                class="errors-profile-informations alert-color"
                *ngIf="formCompanyInformations.get('nom').invalid && submitted"
              >
                Veuillez renseigner votre nom
              </div>
            </div>
            <div class="column-errors-input">
              <input
                [attr.disabled]="userConnectedInfo.userInfo.firstName ? '' : null"
                kendoTextBox
                [placeholder]="'Prénom'"
                formControlName="prenom"
              />
              <div
                class="errors-profile-informations alert-color"
                *ngIf="formCompanyInformations.get('prenom').invalid && submitted"
              >
                Veuillez renseigner votre prénom
              </div>
            </div>
          </div>
          <div class="container-two-column">
            <div class="column-errors-input">
              <input
                [attr.disabled]="userConnectedInfo.userInfo.role ? '' : null"
                kendoTextBox
                [placeholder]="'Fonction'"
                formControlName="role"
              />
              <div
                class="errors-profile-informations alert-color"
                *ngIf="formCompanyInformations.get('role').invalid && submitted"
              >
                Veuillez renseigner votre fonction
              </div>
            </div>
            <div class="column-errors-input">
              <input
                [attr.disabled]="userConnectedInfo.userInfo.phone ? '' : null"
                kendoTextBox
                [placeholder]="'Téléphone'"
                formControlName="phone"
              />
              <div class="errors-profile-informations alert-color" *ngIf="formCompanyInformations.get('phone').invalid">
                Veuillez renseigner votre numero de fixe
              </div>
            </div>
            <div class="column-errors-input">
              <input
                [attr.disabled]="userConnectedInfo.userInfo.mobile ? '' : null"
                kendoTextBox
                [placeholder]="'Mobile'"
                formControlName="mobile"
              />
              <div
                class="errors-profile-informations alert-color"
                *ngIf="formCompanyInformations.get('mobile').invalid"
              >
                Veuillez renseigner votre numéro de portable
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <!-- Formulaire Infos Personnelles -->
  <div *ngIf="typeClient === 'un particulier / indépendant'">
    <form [formGroup]="formUserInformations" *ngIf="!!typeClient" (ngSubmit)="formUpdateUser()">
      <div class="container-block-form-informations">
        <h5>Mes informations</h5>
        <div class="container-three-column">
          <div class="three-input-container">
            <kendo-combobox
              [attr.disabled]="this.userConnectedInfo.userInfo.civ ? '' : null"
              [data]="listCiv"
              [placeholder]="'Civ.'"
              formControlName="civ"
              class="civility-informations"
            >
            </kendo-combobox>
            <div class="errors-profile-informations alert-color" *ngIf="formUserInformations.get('civ').invalid">
              Veuillez renseigner votre civilité
            </div>
          </div>
          <div class="three-input-container">
            <input
              kendoTextBox
              [placeholder]="'Nom'"
              formControlName="nom"
              [attr.disabled]="this.userConnectedInfo.userInfo.name ? '' : null"
            />
            <div class="errors-profile-informations alert-color" *ngIf="formUserInformations.get('nom').invalid">
              Veuillez renseigner votre nom
            </div>
          </div>
          <div class="three-input-container">
            <input
              [attr.disabled]="this.userConnectedInfo.userInfo.firstName ? '' : null"
              kendoTextBox
              [placeholder]="'Prénom'"
              formControlName="prenom"
            />
            <div
              class="errors-profile-informations alert-color"
              *ngIf="formUserInformations.get('prenom').invalid && submitted"
            >
              Veuillez renseigner votre prénom
            </div>
          </div>
        </div>
        <div class="container-three-column">
          <div class="three-input-container">
            <input
              [attr.disabled]="this.userConnectedInfo.userInfo.role ? '' : null"
              kendoTextBox
              [placeholder]="'Fonction'"
              formControlName="role"
            />
            <div
              class="errors-profile-informations alert-color"
              *ngIf="formUserInformations.get('role').invalid && submitted"
            >
              Veuillez renseigner votre fonction
            </div>
          </div>
          <div class="three-input-container">
            <input
              [attr.disabled]="this.userConnectedInfo.userInfo.phone ? '' : null"
              kendoTextBox
              [placeholder]="'Téléphone'"
              formControlName="phone"
            />
            <div
              class="errors-profile-informations alert-color"
              *ngIf="formUserInformations.get('phone').invalid && submitted"
            >
              Veuillez renseigner votre numero de fixe
            </div>
          </div>
          <div class="three-input-container">
            <input
              [attr.disabled]="this.userConnectedInfo.userInfo.mobile ? '' : null"
              class="k-textbox"
              [placeholder]="'Mobile'"
              formControlName="mobile"
              [disabled]="true"
            />
            <div
              class="errors-profile-informations alert-color"
              *ngIf="formUserInformations.get('mobile').invalid && submitted"
            >
              Veuillez renseigner votre numero de mobile
            </div>
          </div>
        </div>
        <div class="row-informations">
          <div class="column-errors-input">
            <input
              [attr.disabled]="this.userConnectedInfo.userInfo.addr.addr ? '' : null"
              kendoTextBox
              [placeholder]="'Adresse'"
              formControlName="adresse"
              class="input-informations"
            />
            <div
              class="errors-profile-informations alert-color"
              *ngIf="formUserInformations.get('adresse').invalid && submitted"
            >
              Veuillez renseigner votre adresse
            </div>
          </div>
        </div>
        <div class="container-two-column">
          <div class="two-input-container">
            <input
              kendoTextBox
              [placeholder]="'Code Postal'"
              formControlName="code_postal"
              class="informations-two-input"
              [attr.disabled]="this.userConnectedInfo.userInfo.addr.postal ? '' : null"
            />
            <div
              class="errors-profile-informations alert-color"
              *ngIf="formUserInformations.get('code_postal').invalid && submitted"
            >
              Veuillez renseigner votre Code Postal
            </div>
          </div>
          <div class="two-input-container">
            <input
              [attr.disabled]="this.userConnectedInfo.userInfo.addr.city ? '' : null"
              kendoTextBox
              [placeholder]="'Ville'"
              formControlName="ville"
              class="informations-two-input"
            />
            <div
              class="errors-profile-informations alert-color"
              *ngIf="formUserInformations.get('ville').invalid && submitted"
            >
              Veuillez renseigner votre ville
            </div>
          </div>
        </div>
        <div class="block-validation-informations">
          <!--<div class="validation-informations">-->
          <!--<p>-->
          <!--DISCLAIMER RGPD, Crebriores animi quorum et turbela maerens protector domesticus populari quo quae-->
          <!--praeteritis prohibebant animi domesticus torrentes Hermogenis egerat protector potuit.-->
          <!--</p>-->
          <!--&lt;!&ndash;TODO REMOVE Commentaire when CGV function avaible &ndash;&gt;-->
          <!--&lt;!&ndash;<input formControlName="cgv" type="checkbox" id="cdc2" class="k-checkbox" />&ndash;&gt;-->
          <!--&lt;!&ndash;<label&ndash;&gt;-->
          <!--&lt;!&ndash;[ngClass]="&ndash;&gt;-->
          <!--&lt;!&ndash;submitted && formUserInformations.get('cgv').invalid&ndash;&gt;-->
          <!--&lt;!&ndash;? 'errors-profile-informations alert-color k-checkbox-label font-size-16'&ndash;&gt;-->
          <!--&lt;!&ndash;: 'k-checkbox-label'&ndash;&gt;-->
          <!--&lt;!&ndash;"&ndash;&gt;-->
          <!--&lt;!&ndash;for="cdc2"&ndash;&gt;-->
          <!--&lt;!&ndash;&gt;&ndash;&gt;-->
          <!--&lt;!&ndash;Je valide les <a (click)="getCGV()" title="conditions générales<">&nbsp;conditions générales&nbsp; </a> de&ndash;&gt;-->
          <!--&lt;!&ndash;vente.&ndash;&gt;-->
          <!--&lt;!&ndash;</label>&ndash;&gt;-->
          <!--</div>-->
          <div class="validation-informations full-size align-right">
            <button class="small-margin colored-text" kendoButton>
              <ng-container *ngIf="!loading; else buttonSubmitted"> Suivant</ng-container>
              <ng-template #buttonSubmitted>
                Chargement...
              </ng-template>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<div *ngIf="displayPopup">
  <kendo-window>
    <kendo-window-titlebar class="small-padding">
      <div class="k-window-title">Attention</div>
    </kendo-window-titlebar>
    <div class="align-center msg-content">
      <p class="small-margin">{{ errorMsg }}</p>
      <button kendoButton type="button" [primary]="true" (click)="closeDialog()">Ok</button>
    </div>
  </kendo-window>
</div>
